import sileo from 'sileo';

const TemplateContent = new sileo.Model('bposeats', 'template-content');
const Template = new sileo.Model('bposeats', 'templates');
const TemplateAmazon = new sileo.Model('bposeats', 'template-amazon-data');
const TemplateEmployments = new sileo.Model('bposeats', 'template-employments');

const DocumentTemplate = new sileo.Model('hqzen','document');
const DocumentTemplateCount = new sileo.Model('hqzen','document-count');

const state = {
    systemTemplates: {},
    customTemplates: {},
    systemTemplatesCount: 0,
    customTemplatesCount: 0
};

const getters = {
    systemTemplates: state => state.systemTemplates,
    customTemplates: state => state.customTemplates,
    systemTemplatesCount: state => state.systemTemplatesCount,
    customTemplatesCount: state => state.customTemplatesCount,
};

const mutations = {
    setSystemTemplates(state, data) {
        state.systemTemplates[`page-${data.page}`] = [...data.templates];
    },

    setCustomTemplates(state, data) {
        let customTemplates = state.customTemplates[`policy-${data.policyPk}`];

        if (!customTemplates) {
            state.customTemplates[`policy-${data.policyPk}`] = {};
        }

        state.customTemplates[`policy-${data.policyPk}`][`page-${data.page}`] = [...data.templates];

    },

    setSystemTemplatesCount(state, count) {
        state.systemTemplatesCount = count;
    },

    setCustomTemplatesCount(state, count) {
        state.customTemplatesCount = count;
    }
};

const actions = {
    createTemplate(context, data) {
        return Template.objects.create(data);
    },

    updateTemplate(context, data) {
        return Template.objects.update({ pk: data.template_id }, data);
    },

    fetchTemplates(context, filters) {
        return Template.objects.filter(filters);
    },

    getTemplatePk(context, pk) {
        return Template.objects.get(pk);
    },

    getTemplate(context, pk) {
        return TemplateContent.objects.get(pk);
    },

    fetchTemplatesContent(context, filters) {
        return TemplateContent.objects.filter(filters);
    },

    async fetchTemplateAmazon() {
        let data = await TemplateAmazon.objects.filter();
        return data.amazon;
    },

    fetchSystemTemplates({ commit, state }, { page = 0, employment_policy__id = -1 }) {
        if (!state.systemTemplates[`page-${page}`]) {
            return new Promise((res, rej) => {
                let top = (page - 1) * 6;

                Template.objects.filter({
                    top,
                    employment_policy__id,
                    is_system_wide: 'True',
                    template_type: 'Contract'
                }).then(response => {
                    if (!response.error) {
                        commit('setCustomTemplatesCount', response.my_template_count);
                        commit('setSystemTemplatesCount', response.system_wide_template_count);
                        commit('setSystemTemplates', {
                            templates: response.templates,
                            page: page
                        });
                    }
                    res(response.templates);
                }).catch(e => {
                    console.error(e);
                    rej(e);
                });
            });
        }

        return state.systemTemplates[`page-${page}`];
    },

    fetchCustomTemplatesByEmploymentPolicyID({ commit, state }, { page = 0, employment_policy__id = -1 }) {
        let policyTemplates = state.customTemplates[`policy-${employment_policy__id}`];

        if (!policyTemplates || (!policyTemplates && !policyTemplates[`page-${page}`])) {
            return new Promise((res, rej) => {
                let top = (page - 1) * 6;

                Template.objects.filter({
                    top,
                    employment_policy__id,
                    template_type: 'Contract'
                }).then(response => {
                    if (!response.error) {
                        commit('setCustomTemplatesCount', response.my_template_count);
                        commit('setSystemTemplatesCount', response.system_wide_template_count);
                        commit('setCustomTemplates', {
                            templates: response.templates,
                            policyPk: employment_policy__id,
                            page: page
                        });
                    }
                    res(response.templates);
                }).catch(e => {
                    console.error(e);
                    rej(e);
                });
            });
        }

        return policyTemplates[`page-${page}`];
    },

    fetchTemplateEmployments(context, filters) {
        return TemplateEmployments.objects.filter(filters);
    },

    fetchDocumentTemplates(context, filters) {
        return DocumentTemplate.objects.filter(filters);
    },

    fetchDocumentTemplateCount(context, filters) {
        return DocumentTemplateCount.objects.filter(filters);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
